import { documentsActions } from './actions';
import { useGetItems } from '../hooks';
import { DocsGroups } from '../../api';
import { DocsState } from './types';
import { UseGetItems } from '../types';


const documentsPath = 'documents';

export function useDocs(group: DocsGroups): UseGetItems<DocsState['data']>;
export function useDocs<TReturn>(group: DocsGroups, formatting: (data: DocsState['data']) => TReturn): UseGetItems<TReturn>;
export function useDocs<TReturn = DocsState['data']>(
    group: DocsGroups,
    formatting?: (data: DocsState['data']) => TReturn,
) {
    const { data, ...rest } = useGetItems<DocsState['data'], Parameters<typeof documentsActions.getDocs>[0]>({
        path: `${documentsPath}.${group}`,
        loadAction: documentsActions.getDocs,
        actionPayload: { group },
    });

    return {
        data: formatting ? formatting(data) : data ?? [],
        ...rest,
    };
}
